import React, { memo } from 'react';
import { Box, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

const useStyles = makeStyles<AlyceTheme>(({ palette }) => ({
  privacyLinks: {
    marginRight: 16,
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    textDecoration: 'underline',
    color: palette.grey.regular,
    '&:hover': {
      color: palette.grey.regular,
    },
  },
  allRightText: {
    color: palette.grey.regular,
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    marginRight: 30,
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <Box data-testid="footerBox" width={1} display="flex" alignItems="flex-end">
      <Box width={1} display="flex" alignItems="center" justifyContent="center">
        <p className={classes.allRightText}>Powered by Alyce, Inc</p>
        <Link
          className={classes.privacyLinks}
          href="https://www.alyce.com/terms-of-use/"
          target="_blank"
          underline="hover"
        >
          Terms
        </Link>
        <Link
          className={classes.privacyLinks}
          href="https://www.alyce.com/privacy-policy/"
          target="_blank"
          underline="hover"
        >
          Privacy
        </Link>
        <Link
          className={classes.privacyLinks}
          href="https://www.alyce.com/contact-support-recipients"
          target="_blank"
          underline="hover"
        >
          Contact support
        </Link>
      </Box>
    </Box>
  );
};

export default memo(Footer);
